import { Box, Typography } from "@mui/material";

type Props = {
  step: string;
  title: string;
  description: string;
  icon: React.ReactNode;
};

export function StepCard({ step, title, description, icon }: Props) {
  return (
    <div className="w-full sm:w-[250px] rounded-xl overflow-hidden bg-white shadow">
      {/* スマホ:flex（横長） / PC:block（縦長） */}
      <div className="flex sm:block">
        {/* 赤ヘッダ：スマホは左帯、PCは上帯 */}
        <div className="bg-red-500 text-white relative flex-shrink-0 w-24 sm:w-auto h-auto sm:h-[120px]">
          <span className="text-2xl sm:text-3xl font-bold absolute top-3 left-4">
            {step}
          </span>

          <div className="absolute inset-0 flex items-center justify-center">
            {/* スマホは少し小さめ */}
            <div className="scale-75 sm:scale-100">{icon}</div>
          </div>
        </div>

        {/* テキスト：スマホは右側、PCは下側 */}
        <Box
          sx={{
            p: 2,
            textAlign: { xs: "left", sm: "center" },
            flex: "1 1 auto",
            minWidth: 0,
          }}
        >
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={(theme) => ({
              color: theme.palette.primary.main,
              fontSize: { xs: "1rem", sm: undefined },
            })}
          >
            {title}
          </Typography>

          <Typography
            variant="body2"
            sx={(theme) => ({
              mt: 1,
              color: theme.palette.primary.main,
              fontSize: { xs: "0.875rem", sm: undefined },
              lineHeight: 1.6,
            })}
          >
            {description}
          </Typography>
        </Box>
      </div>
    </div>
  );
}
